import React from 'react'
import PropTypes from 'prop-types'
import UserRoleHistoryListItem from "./UserRoleHistoryListItem";

const UserRoleHistoryList = ({data}) => {

    return (
        <div className="d-flex flex-column">
            {data && data.map(value => <UserRoleHistoryListItem key={value.id} {...value}/>)}
        </div>
    )

}

UserRoleHistoryList.propTypes = {
    data: PropTypes.array,
}

export default UserRoleHistoryList